import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SupplierPaymentCreationPage } from '@/features/suppliers/components/SupplierPaymentCreationPage';

const searchSchema = z.object({
  type: z.enum(['reglement', 'acompte']).optional(),
  invoiceRef: z.string().optional(),
});

export const Route = createFileRoute('/$commiteeSlug/suppliers/$supplierId/payments/create')({
  validateSearch: searchSchema,
  component: SupplierPaymentCreationPage,
});
